import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], args: { [key: string]: any }): any {
    if (!value) {
      return [];
    }
    return value.filter(x => {
      for (const i in args) {
        if ((x[i]?.toLowerCase())?.includes(args[i]?.toLowerCase())) {
          return true;
        }
      }
      return false;
    });
  }
}
